import { queryOptions } from '@tanstack/react-query'

import { fetchFormSettings } from '#admin/features/registration-form/api.ts'

/**
 * Under `ticket`, beside the registrations that read it: a change to the form changes what the
 * New registration page and every participant sheet render, and invalidating `['ticket']` after a
 * form edit is what keeps an open registration from showing the old questions.
 */
export const formSettingsQuery = () =>
  queryOptions({
    queryKey: ['ticket', 'registration-form'],
    queryFn: ({ signal }) => fetchFormSettings(signal),
    staleTime: 30_000,
  })
